import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import { Spacer } from "../../design-system/atoms/layout-primitives"
import { T } from "../../design-system/atoms/text"
import VariantContainer from "../../design-system/atoms/variant-container"
import SdkProjectsCarousel from "../developer-tools/sdk-projects.carousel"
import FadedTitle from "../shared/faded-title"
import { CopyText } from "./carousel.style"

export default function Carousel() {
  const query = useStaticQuery(graphql`
    query {
      fadeTitle: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/projects_fade_title.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  return (
    <VariantContainer
      variants={[
        css`
          display: flex;
          flex-direction: column;
        `,
      ]}
    >
      <Spacer height={{ sm: "64px", lg: "128px" }} />
      <FadedTitle
        title="Built with Mappedin SDKs"
        image={query.fadeTitle.publicURL}
        alt="Projects"
        fadeSettings={{ lg: "center" }}
        textAlign="center"
        lg={T.lg.h2`500`}
      />
      <CopyText>
        With support from Mappedin’s Integrations team, clients can design and
        build a unique experience that fits seamlessly into any platform.
      </CopyText>
      <Spacer height={{ sm: "32px", md: "48px", lg: "64px" }} />
      <SdkProjectsCarousel />
      <Spacer height={{ sm: "64px", lg: "96px" }} />
    </VariantContainer>
  )
}
